import { render } from "./MetricasNegocio.vue?vue&type=template&id=4f2529db&scoped=true"
import script from "./MetricasNegocio.vue?vue&type=script&lang=js"
export * from "./MetricasNegocio.vue?vue&type=script&lang=js"

import "./MetricasNegocio.vue?vue&type=style&index=0&id=4f2529db&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2529db"]])

export default __exports__